import mock from './mock';
import './db/hsse-dashboard-db';
// import './db/action-plan-db';

mock.onAny().passThrough();
